const CaseStudyDetails = (props) => {
    return (
        <div className="select-none">
            
        </div>
    );
}

export default CaseStudyDetails;